

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETADMINSITESETTINGS= createAsyncThunk(
  "getSiteSettings/getSiteSettings",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getSiteSettingsSlice = createSlice({
  name: "getSiteSettingsSlice",
  initialState: {
    getSiteSettings: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetSiteSettings: (state) => {
        state.getSiteSettings.loading = false
        state.getSiteSettings.error = false
        state.getSiteSettings.data = []
        state.getSiteSettings.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETADMINSITESETTINGS.fulfilled, (state, action) => {
      state.getSiteSettings = {
        ...state.getSiteSettings,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETADMINSITESETTINGS.pending, (state, action) => {
      state.getSiteSettings = {
        ...state.getSiteSettings,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETADMINSITESETTINGS.rejected, (state, action) => {
      state.getSiteSettings = {
        ...state.getSiteSettings,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getSiteSettingsAction = {
    GETADMINSITESETTINGS,
};

export { getSiteSettingsAction };
export default getSiteSettingsSlice.reducer;
export const {setInitialStateOfgetSiteSettings} = getSiteSettingsSlice.actions
